import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import DesignationEdit from './DesignationEdit';

const Designation = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
    <p></p>
    <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
        <DataField 
            editMode={false} 
            lg={10} 
            md={24} 
            options={props.ad.EMPLOYEE_DESIG_CODE} 
            type="Select" 
            name="designation" 
            value={data.designation_code} 
        />
        <DataField 
            editMode={false} 
            lg={7} 
            md={24} 
            name="joining date" 
            value={data.date_join ? data.date_join.format('DD-MM-YYYY') : null} 
        />
        <DataField 
            editMode={false} 
            lg={7} 
            md={24} 
            name="release date" 
            value={data.date_release ? data.date_release.format('DD-MM-YYYY') : null} 
        />
    </Row>  
    <p></p>
</div>

            );
        })
           
        :
        <>
            <p></p>
            <DesignationEdit desigOptions = {props.ad.EMPLOYEE_DESIG_CODE} data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Designation